import { render } from "./points-history.vue?vue&type=template&id=943ad9d0&ts=true"
import script from "./points-history.vue?vue&type=script&lang=ts"
export * from "./points-history.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__